/**
 * Ontoloji yönetimi saga — V2 Faz F.
 *
 * Okuma: SchemaController (`/api/schema/*`, anonim — katalog formu da kullanır)
 * Yönetim: OntologyAdminController (`/api/admin/ontology/*`, admin)
 */
import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";

import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { SagaActionParams, SagaGenericParams } from "src/request/types";

import {
  CategoryCardsPage,
  CategoryCoverage,
  OntologyOverview,
  SchemaCategory,
  SchemaSector,
  SectorCoverage,
  UnmappedGroup,
} from "./type";

/** Sayılar: sektör/kategori/attribute + veri kalitesi boşlukları. */
export const getOntologyOverview = createAction(
  "GET_ONTOLOGY_OVERVIEW",
  ({ payload }: SagaActionParams<OntologyOverview>) => ({
    payload,
    url: "/api/admin/ontology/overview",
  })
);

/** Ontolojiye eşlenmemiş tenant kategorileri — ürünleri aramada görünmüyor. */
export const getUnmappedGroups = createAction(
  "GET_ONTOLOGY_UNMAPPED",
  ({ payload }: SagaActionParams<UnmappedGroup[]>) => ({
    payload,
    url: "/api/admin/ontology/unmapped",
  })
);

/** Sektör başına ürün ve özellik doluluk oranı. */
export const getOntologyCoverage = createAction(
  "GET_ONTOLOGY_COVERAGE",
  ({ payload }: SagaActionParams<SectorCoverage[]>) => ({
    payload,
    url: "/api/admin/ontology/coverage",
  })
);

/** Tenant kategorisini bir ontoloji kategorisine bağla. */
export const mapAssetGroup = createAction(
  "MAP_ASSET_GROUP_TO_TAXONOMY",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/ontology/map",
  })
);

/** Kapsam "Detay" — sektörün altındaki kategoriler ve doluluk. */
export const getSectorCategories = createAction(
  "GET_ONTOLOGY_SECTOR_CATEGORIES",
  ({ payload, id }: SagaActionParams<CategoryCoverage[]>) => ({
    payload,
    url: "/api/admin/ontology/coverage/" + id + "/categories",
  })
);

/** Bir kategoriye bağlı ürünler — ad, il, ilçe, tedarikçi. */
export const getCategoryCards = createAction(
  "GET_ONTOLOGY_CATEGORY_CARDS",
  ({ payload, params }: SagaActionParams<CategoryCardsPage>) => ({
    payload,
    url: "/api/admin/ontology/cards" + (params ?? ""),
  })
);

export const getSchemaSectors = createAction(
  "GET_SCHEMA_SECTORS",
  ({ payload }: SagaActionParams<SchemaSector[]>) => ({
    payload,
    url: "/api/schema/sectors?locale=tr",
  })
);

export const getSchemaCategories = createAction(
  "GET_SCHEMA_CATEGORIES",
  ({ payload, id }: SagaActionParams<any>) => ({
    payload,
    url: "/api/schema/sectors/" + id + "/categories?locale=tr",
  })
);

export const getSchemaDetail = createAction(
  "GET_SCHEMA_DETAIL",
  ({ payload, id }: SagaActionParams<any>) => ({
    payload,
    url: "/api/schema/" + id + "?locale=tr",
  })
);

const ontologySaga = [
  takeLatest<any>(getOntologyOverview.toString(), (payload: SagaGenericParams<OntologyOverview>) =>
    getSaga<OntologyOverview>(payload)
  ),
  takeLatest<any>(getUnmappedGroups.toString(), (payload: SagaGenericParams<UnmappedGroup[]>) =>
    getSaga<UnmappedGroup[]>(payload)
  ),
  takeLatest<any>(getOntologyCoverage.toString(), (payload: SagaGenericParams<SectorCoverage[]>) =>
    getSaga<SectorCoverage[]>(payload)
  ),
  takeLatest<any>(getSectorCategories.toString(), (payload: SagaGenericParams<CategoryCoverage[]>) =>
    getSaga<CategoryCoverage[]>(payload)
  ),
  takeLatest<any>(getCategoryCards.toString(), (payload: SagaGenericParams<CategoryCardsPage>) =>
    getSaga<CategoryCardsPage>(payload)
  ),
  takeLatest<any>(getSchemaSectors.toString(), (payload: SagaGenericParams<SchemaSector[]>) =>
    getSaga<SchemaSector[]>(payload)
  ),
  takeLatest<any>(getSchemaCategories.toString(), (payload: SagaGenericParams<any>) =>
    getSaga<any>(payload)
  ),
  takeLatest<any>(getSchemaDetail.toString(), (payload: SagaGenericParams<any>) =>
    getSaga<any>(payload)
  ),
  takeLatest<any>(mapAssetGroup.toString(), (payload: SagaGenericParams<any>) => postSaga<any>(payload)),
];

export default ontologySaga;
